/** @jsx jsx */
/** @jsxFrag null */
import {jsx} from 'panel';

import {SvgIconEl} from 'common/components/svg-icon';

import {Section, SubSection} from './utils';

export function StylesSection() {
  return (
    <Section title='Styles'>
      <SubSection title='.mp-panel'>
        <p sel='.desc'>To create a panel styled container.</p>

        <div sel='.example.block'>
          <div sel='.mp-panel.first-panel'>
            <h2>Here is one main panel</h2>
          </div>
          <div sel='.mp-panel'>
            <div sel='.mp-panel-section'>
              <h3>Here is another one below it</h3>
            </div>
            <div sel='.mp-panel-section'>
              <p>This one has sections.</p>
            </div>
            <div sel='.mp-panel-section'>
              <p>Multiple, multiple...</p>
            </div>
            <div sel='.mp-panel-section'>
              <p>...sections</p>
            </div>
          </div>
        </div>
      </SubSection>

      <SubSection title='.mp-card-header'>
        <p sel='.desc'>Styled card header</p>

        <div sel='.example.block.mp-card-header'>
          <div sel='.mp-card-header'>
            <div sel='.mp-card-header-title'>Card header</div>
            <div sel='.mp-card-header-close'>
              <SvgIconEl attrs={{icon: `x`}} />
            </div>
          </div>
        </div>
      </SubSection>

      <SubSection title='.mp-skeleton'>
        <p sel='.desc'>`.mp-skeleton-header`, `.mp-skeleton-large`, `.mp-skeleton-medium`, and `.mp-skeleton-small`.</p>
        <p sel='.desc'>For when you wish to show a skeleton of a page or element that is loading.</p>

        <div sel='.example.block'>
          <div sel='.mp-skeleton-header' />
          <div sel='.mp-skeleton-large' />
          <div sel='.mp-skeleton-medium' />
          <div sel='.mp-skeleton-small' />
        </div>

        <p sel='.desc'>
          You can even nest them inside other elements if you wrap inside an `.mp-skeleton-wrapper` and they will still
          load together.
        </p>

        <div sel='.example.block'>
          <div sel='.mp-skeleton-wrapper'>
            <div sel='.mp-panel'>
              <div sel='.mp-skeleton-large' />
            </div>
            <div sel='.mp-panel'>
              <div sel='.mp-skeleton-large' />
            </div>
            <div sel='.mp-panel'>
              <div sel='.mp-skeleton-large' />
            </div>
          </div>
        </div>
      </SubSection>
    </Section>
  );
}
